import React, { Component } from 'react';
import StyleSheet from 'stilr';
import ResultRow from './result-row';

const styles = StyleSheet.create({
  container: {
    counterReset: 'section',
    marginBottom: '2em'
  },
  resultContainer: {
    position: 'relative',
    marginBottom: '2em',

    ':not(.hidden):before': {
      font: 'normal 15px/15px arial, sans-serif',
      position: 'absolute',
      left: -8,
      top: -8,
      minWidth: 25,
      textAlign: 'center',
      backgroundColor: '#d3d3d3',
      padding: 5,
      borderRadius: 15,
      border: '1px solid #d3d3d3',
      color: '#333333',
      zIndex: 10,
      counterIncrement: 'section',
      content: 'counter(section)'
    }
  },

  resultDiscounted: {
    ':not(.hidden):before': {
      backgroundColor: '#FFEE00',
      borderColor: '#FFDD00',
      color: '#000000'
    }
  },

  moreContainer: {
    margin: '1em auto 2em',
    textAlign: 'center'
  },
  moreBtn: {
    minWidth: '30%'
  },
  separator: {
    display: 'flex',
    alignItems: 'center',
    margin: '15px',

    ':before': {
      flex: '1',
      content: '""',
      padding: '1px',
      backgroundColor: 'lightgrey',
      margin: '10px'
    },
    ':after': {
      flex: '1',
      content: '""',
      padding: '1px',
      backgroundColor: 'lightgrey',
      margin: '10px'
    }
  }
});

class DisplayResults extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { results } = this.props;

    return (
        <div>
        {results.map(result => {
          const key = result.get('id');
          return (
            <div
              key={key.substr(-6)}
              className={[
                styles.resultContainer,
                result.get('tagline')
                  ? styles.resultDiscounted
                  : null
              ]
                .filter(Boolean)
                .join(' ')}
            >
              <ResultRow data={result} addressId={this.props.addressId} filtersUsed={this.props.filtersUsed} siteId={this.props.siteId} feed={this.props.feed} url={this.props.url} />
            </div>
          );
        })}

        <div>display: {results.size}</div>
      </div>
    );
  }
}

export default DisplayResults;
